import { CURRENCY_PREFIX } from './types';

/**
 * Safely retrieves the currency prefix for a given locale.
 * Falls back to the en-US prefix if the locale is not found.
 */
export const getCurrencyPrefix = (locale: string): string => {
  if (locale in CURRENCY_PREFIX) {
    return CURRENCY_PREFIX[locale as keyof typeof CURRENCY_PREFIX];
  }
  return CURRENCY_PREFIX['en-US'];
};
